import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { PageServiceService } from 'src/app/Services/page-service.service';
import { NotifyService } from 'src/app/Services/notify.service';
import { MatDialog } from '@angular/material/dialog';
import { log } from 'util';
import { AddPageComponent } from '../../AppBaseComponents/add-page/add-page.component';
import { ImportApiObjectsComponent } from '../../AppBaseComponents/import-api-objects/import-api-objects.component';
import { WebObjectTypeService } from '../../Services/web-object-type.service';
import { WebobjectServiceService } from '../../Services/webobject-service.service';
import { AddWebObjectComponent } from 'src/app/AppBaseComponents/add-web-object/add-web-object.component';
import { AddApiObjectComponent } from 'src/app/AppBaseComponents/add-api-object/add-api-object.component';
import { SharedService } from 'src/app/Services/shared.service';
import { ConfirmDialogModel, DialogComponent } from 'src/app/AppBaseComponents/dialog/dialog.component';
import { ValidationService } from 'src/app/Services/validation.service';
import { SelectObjectTypeComponent } from 'src/app/AppBaseComponents/select-object-type/select-object-type.component';
import { ApiObjectService } from 'src/app/Services/api-object.service';
import { TargetObjectService } from 'src/app/Services/target-object.service';
import { FeatureAccessService } from 'src/app/Services/feature-access.service';
@Component({
  selector: 'ze-studio-view',
  templateUrl: './studio-view.component.html',
  styleUrls: ['./studio-view.component.scss']
})
export class StudioViewComponent implements OnInit {
  selectedWebPage: any;
  delConfirmElement: any;
  repository: any;
  elements: any;
  page: any;
  currentPageObject: any;
  currentPageElements: any;
  element_ids = [];
  elementsPerPage = [];


  _webpageSub: Subscription;
  _webObjectTypeSub: Subscription;
  _webObjectSub: Subscription;

  @Output() selectElem = new EventEmitter();
  public webpages: any;
  public webobjecttype: any;  
  public targetobjects: any;
  public webobjects: any;
  public apiobjects: any;
  public obj_to_del: string;
  public currentWebPage: string = "";
  public selectedElement: string = "Add New Element"
  public WebPageMethod = "new";
  public wot;
  public newWP = { name: "", url: "", description: "", webobjects: [], apiobjects: [] }
  public newElement = { logical_name: "", name: "", xpath: "", id: "", class: "", css: "", link: "", horizontal_index:"",  partial_link: "", tag: "", type: "", desc: "", webobjectType: { _id: "" } };
  public webobjectsFiltered;
  public targetobjectsFiltered;
  public currentWebObjectType = "";
  public highlightedIds: string[] = [];
  constructor(
    private fb: FormBuilder,
    private pageServices: PageServiceService,
    private webObjectTypeService: WebObjectTypeService,
    private targetObjectService: TargetObjectService,
    private apiObjectService: ApiObjectService,
    private webobjectServiceService: WebobjectServiceService,
    private notifys: NotifyService,
    public router: Router,
    public dialog: MatDialog,
    private _sharedService: SharedService,
    private validateService: ValidationService,
    private featureAccessService: FeatureAccessService
  ) { this.getWebPages(); }

  ngOnInit() {
    this.getWebObjectType();
    this.webobjecttype = this.webObjectTypeService.getItems();
    // this.startListeners();
    this.loadWebObjectTypeList();
  }
  getWebObjectType() {
    this.webobjecttype;
  }

  getWebObjects() {
    this._sharedService.loaderHide.emit(true)
    this.webobjectServiceService.getObjects(this.currentWebPage).subscribe(data => {
      this.webobjects = data['data'].filter(Boolean);
      this.webobjectsFiltered = this.webobjects;
      this._sharedService.loaderHide.emit(false);
      this.notifys.notify('success', 'Success', 'Web Objects Fetched');
    }, error => {
      this._sharedService.loaderHide.emit(false);
    });
  }

  getTargetObjects() {
    this._sharedService.loaderHide.emit(true)
    this.targetObjectService.getObjects(this.currentWebPage).subscribe(data => {
      this.targetobjects = data['data'].filter(Boolean);
      this.targetobjectsFiltered = this.targetobjects;
      this._sharedService.loaderHide.emit(false);
      this.notifys.notify('success', 'Success', 'Web Objects Fetched');
    }, error => {
      this._sharedService.loaderHide.emit(false);
    });
  }

  getWebPages() {
    this._sharedService.loaderHide.emit(true);
    this.pageServices.getItems().subscribe(data => {
      this.webpages = data['data'].filter(Boolean);
      this._sharedService.loaderHide.emit(false);
    }, error => {
      this._sharedService.loaderHide.emit(false);
    });
  }
  changePage(value) {
    this.currentWebPage = value;
    // this.getDetailsSelectedPage(value);
    this.getTargetObjects();
  }

  // getDetailsSelectedPage(value) {
  //   this.pageServices.findByObjectId(value).subscribe(data => {
  //     this.selectedWebPage = data.data;
  //   })
  // }

  deleteWebObject(wo_id, targetType) {
    const message = `Are you sure you want to delete this?`;
    const dialogData = new ConfirmDialogModel("Delete !!!", message);
    const dialogRef = this.dialog.open(DialogComponent, {
      data: dialogData
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this._sharedService.loaderHide.emit(true)
        if (targetType == "API") {
          this.apiObjectService.deleteObject(wo_id).subscribe(
            data => {
              this.getTargetObjects();
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('warning', 'Deleted', 'API Object Deleted ');
            },
            error => {
              this._sharedService.loaderHide.emit(false)
            }
          );
        } else {
          this.webobjectServiceService.deleteObject(wo_id).subscribe(
            data => {
              this.getTargetObjects();
              this._sharedService.loaderHide.emit(false)
              this.notifys.notify('warning', 'Deleted', 'Web Object Deleted ');
            },
            error => {
              this._sharedService.loaderHide.emit(false)
            }
          );
        }
      }
      else {
        log("Deletion Aborted By User!!!");
        this.notifys.notify('warning', 'Aborted', "Deletion Aborted By User!!!");
      }
    });
  }

  deleteConfirm() {
    let data = {
      webpage: {
        _id: this.currentWebPage
      },
      webobject: { _id: this.obj_to_del, deleted: 1 }
    }
    this.pageServices.editWebObject(data);
    this.notifys.notify('warning', 'Deleted', 'Web Object Deleted ');
  }

  // startListeners() {
  //   this._webpageSub = this.pageServices.webpages.subscribe(doc => {
  //     this.webpages = doc;
  //     this.webpages = this.webpages.webPages;
  //   });
  //   this._webObjectTypeSub = this.pageServices.webobjecttype.subscribe(doc => {
  //     this.webobjecttype = doc;
  //   });
  //   this._webObjectSub = this.pageServices.webobjects.subscribe(doc => {
  //     this.webobjects = doc;
  //     this.webobjects = this.webobjects.elements;
  //   });
  // }

  addNewPage(flag) {
    let del = 0;
    let data_to_start = {
      project: {
        _id: ""
      },
      webpage: {
        page_name: this.newWP.name,
        page_url: this.newWP.url,
        page_description: this.newWP.description,
        deleted: del,
      }
    }
    if (flag == 'deleted') {
      data_to_start.webpage.deleted = 1
    }
    if (flag == 'deleted' || this.WebPageMethod == 'edit') {
      data_to_start.webpage["_id"] = this.currentWebPage;
      this.pageServices.editWebpage(data_to_start);
    }
    else if (this.WebPageMethod == 'new') {
      this.pageServices.addWebPage(data_to_start);
    }
    this.notifys.onSuccess('Success', 'Web Page Created');
  }

  loadWebObjectTypeList() {
    this.pageServices.getWebObjectTypeList();
  }

  addNewElement() {
    // Open dialog to select object type
    const dialogRef = this.dialog.open(SelectObjectTypeComponent, {
      data: {}
    });
  
    dialogRef.afterClosed().subscribe(selectedType => {
      if (!selectedType) return;
  
      this.selectedElement = "Add New Element";
      
      let componentToOpen;
      let dialogData;
      let panelClass; // To assign different CSS classes for dialog
  
      if (selectedType.toLowerCase() === 'api') {
        componentToOpen = AddApiObjectComponent;
        dialogData = {
          webpage: this.currentWebPage,
          selectedObjectType: selectedType
        };
        panelClass = 'api-dialog-container';
      } else {
        componentToOpen = AddWebObjectComponent;
        dialogData = {
          webpage: this.currentWebPage,
          showView: 'displaywebobject',
          selectedObjectType: selectedType
        };
        panelClass = 'web-dialog-container';
      }
  
      const dialogRef2 = this.dialog.open(componentToOpen, {
        data: dialogData,
        panelClass: panelClass // custom class applied here
      });
  
      dialogRef2.afterClosed().subscribe(result => {
        if (result != undefined) {
          if (this.isNameNotAvailable(result.name, this.targetobjects)) {
            this.notifys.notify('warning', 'Duplicate Object', "Duplicate Object Name, please rename");
            return;
          }
          if (result.type == "WEB") {    
            this.validateService.validateWebObject(result);
    
            this.webobjectServiceService.addWebObject(this.currentWebPage, result).subscribe(
              data => {
                this.getTargetObjects();
                if (data.data.matchingId.length === 0) {
                  this.notifys.notify('success', 'Success', 'Object Successfully added');
                } else {
                  this.highlightedIds = data.data.matchingId;
                  this.notifys.notify('error', 'Error', 'Cannot duplicate');
                  setTimeout(() => {
                    this.highlightedIds = [];
                  }, 10000);
                }
              },
              error => {
                this.notifys.notify('error', 'Error', error);
              }
            );
          } else if (result.type == "API") {
            this.apiObjectService.addApiObject(this.currentWebPage, result).subscribe(
              data => {
                this.getTargetObjects();
                if (data.data.matchingId.length === 0) {
                  this.notifys.notify('success', 'Success', 'Object Successfully added');
                } else {
                  this.highlightedIds = data.data.matchingId;
                  this.notifys.notify('error', 'Error', 'Cannot duplicate');
                  setTimeout(() => {
                    this.highlightedIds = [];
                  }, 10000);
                }
              },
              error => {
                this.notifys.notify('error', 'Error', error);
              }
            );
          }
          
        }
      });
    });
  }
  
  isNameNotAvailable(name: string, list): boolean {
    for (let object of list)
      if (object.name == name)
        return true;
    return false;
  }

  addnewPageDiag() {
    var dialogRef = this.dialog.open(AddPageComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result != undefined) {
        if (this.isNameNotAvailable(result.name, this.webpages)) {
          this.notifys.notify('warning', 'Duplicate Page', "Duplicate Page Name, please rename");
          return;
        }
        this._sharedService.loaderHide.emit(true);
        this.pageServices.addWebPage(result).subscribe(
          data => {
            this.getWebPages();
            this._sharedService.loaderHide.emit(false)
            this.notifys.notify('success', 'Success', "New Web Page Added");
          },
          error => {
            this.notifys.notify('error', 'Error', error);
            this._sharedService.loaderHide.emit(false)
            this.notifys.notify('error', 'Error', "unable to add webpage");
          }
        );
      }
    });
  }

  setApiandWebObjects() {
    this.webobjects = this.targetobjects.filter(to => (to.type == undefined || to.type == null ||to.type == "WEB"));    
    this.apiobjects = this.targetobjects.filter(to => to.type == "API");
  }

  openEditWebPageModal(webpage) {
    let data = this.webpages.filter((ele) => {
      return ele._id == this.currentWebPage;
    })
    this.setApiandWebObjects();
    const dialogRef = this.dialog.open(AddPageComponent, {
      data: { webPage: { name: data[0].name, url: data[0].url, _id: data[0]._id, desc: data[0].desc, webobjects: this.webobjects, apiobjects: this.apiobjects } }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this._sharedService.loaderHide.emit(true)
        this.pageServices.updatePage(result).subscribe(data => {
          this.getWebPages();
          this._sharedService.loaderHide.emit(false)
          this.notifys.notify('success', 'Success', "New Web Page Added");
        }, error => {
          this._sharedService.loaderHide.emit(false)
          this.notifys.notify('error', 'Failed', "unable to update ");
        });
      }
    });
  }

  editElement(elem) {
    this.selectedElement = elem.logical_name;
    this.newElement = elem;

    if (elem.type === 'API') {
      let dialogRef = this.dialog.open(AddApiObjectComponent, {
        data: {
          element: (JSON.parse(JSON.stringify(elem))), 
          webpage: this.currentWebPage, 
          showView: 'selectWebPageOptions'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._sharedService.loaderHide.emit(true);
          // this.validateService.validateWebObject(result);
          this.apiObjectService.updateObject(this.currentWebPage, result).subscribe(
            data => {
              this.getTargetObjects();
              this._sharedService.loaderHide.emit(false)
            },
            error => {
              this._sharedService.loaderHide.emit(false)
            }
          );
        }
      });
    } else {
      let dialogRef = this.dialog.open(AddWebObjectComponent, {
        data: {
          element: (JSON.parse(JSON.stringify(elem)))
          , webpage: this.currentWebPage, showView: 'displaywebobject'
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this._sharedService.loaderHide.emit(true);
          this.validateService.validateWebObject(result);
          this.webobjectServiceService.updateObject(this.currentWebPage, result).subscribe(
            data => {
              this.getTargetObjects();
              this._sharedService.loaderHide.emit(false)
            },
            error => {
              this._sharedService.loaderHide.emit(false)
            }
          );
        }
      });
    }    
  }
  
  // selectElement(elem) {
  //   this.selectElem.emit(elem);
  // }
  
  // filterByid(element, array, prop) {
  //   for (var ele of array) {
  //     if (ele.type[prop] != element[prop])
  //       ele.hidden = true;
  //   }
  //   return array
  // }

  reset(array) { for (var ele of array) ele.hidden = false; }

  filterByWebObjectType(filteringWebobjectType) {
    this.reset(this.targetobjects);
    if (this.currentWebObjectType == filteringWebobjectType) {
      this.currentWebObjectType = "";
      this.targetobjectsFiltered = this.targetobjects;
      return
    }
    this.currentWebObjectType = filteringWebobjectType;
    this.targetobjectsFiltered = this.targetobjects.filter(to => to.webobjectType == filteringWebobjectType)
  }

  copyObject(element) {
  this.selectedElement = element.logical_name;
  this.newElement = element;
  
  let elementCopy = JSON.parse(JSON.stringify(element));
  elementCopy.name = elementCopy.name + "copy_";
  
  let componentToOpen;
  let dialogData;
  
  if (element.type === 'API') {
    componentToOpen = AddApiObjectComponent;
    dialogData = {
      element: elementCopy,
      webpage: this.currentWebPage,
      showView: 'selectWebPageOptions'
    };
  } else {
    componentToOpen = AddWebObjectComponent;
    dialogData = {
      element: elementCopy,
      webpage: this.currentWebPage,
      showView: 'selectWebPageOption'
    };
  }
  
  let dialogRef = this.dialog.open(componentToOpen, {
    data: dialogData
  });
  
  dialogRef.afterClosed().subscribe(result => {
    if (result) {
      console.log("result", result);
      this._sharedService.loaderHide.emit(true);
      
      if (element.type !== 'API') {
        this.validateService.validateWebObject(result);
      }
      
      if (element.type === 'API') {
        this.apiObjectService.addApiObject(result.selectedWebPageId, result).subscribe(
          data => {
            this.getTargetObjects();
            this._sharedService.loaderHide.emit(false);
            if (!data.data.matchingId) {
              this.notifys.notify('success', 'Success', "Object Duplicated");
            } else {
              this.highlightedIds = data.data.matchingId;
              this.notifys.notify('info', 'INFO', "Already such a object exists");
              setTimeout(() => {
                this.highlightedIds = [];
              }, 10000);
            }
          },
          error => {
            this._sharedService.loaderHide.emit(false);
            this.notifys.notify('error', 'Error', error);
          }
        );
      } else {
        this.webobjectServiceService.addWebObject(result.selectedWebPageId, result).subscribe(
          data => {
            this.getTargetObjects();
            this._sharedService.loaderHide.emit(false);
            if (!data.data.matchingId) {
              this.notifys.notify('success', 'Success', "Object Duplicated");
            } else {
              this.highlightedIds = data.data.matchingId;
              this.notifys.notify('info', 'INFO', "Already such a object exists");
              setTimeout(() => {
                this.highlightedIds = [];
              }, 10000);
            }
          },
          error => {
            this._sharedService.loaderHide.emit(false);
            this.notifys.notify('error', 'Error', error);
          }
        );
      }
    }
  });
}

  getIconFromWebObjectType(webobjectName: string): string {
    if (webobjectName == "")
      return "web";
    let wotObject = this.webobjecttype.find(object => object.name == webobjectName)
    if (wotObject)
      return wotObject.icon;
    return this.webobjecttype.find(object => object.name == 'Other').icon
  }

  openImportApiObjects() {
    if (this.featureAccessService.getAccess('API_TESTING') !== 'WRITE') {
      return;
    }
    const dialogRef = this.dialog.open(ImportApiObjectsComponent, {
      data: {
        webpage: this.currentWebPage
      }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.getWebPages();
      }
    });
  }
}
